import { Link } from "react-router-dom";
import { Sofa, Leaf, Recycle, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SERVICIOS_INFO, PUNTO_LIMPIO_INFO } from "@/mock";

const ICONS = { Sofa, Leaf, Recycle };
const TODOS_LOS_SERVICIOS = [...Object.values(SERVICIOS_INFO), PUNTO_LIMPIO_INFO];

export default function ServicesSection() {
  return (
    <section id="servicios" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-municipal font-semibold text-sm uppercase tracking-widest">Servicios</span>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl text-municipal mt-3">
            ¿Qué tipo de recogida necesitas?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {TODOS_LOS_SERVICIOS.map((servicio) => {
            const Icon = ICONS[servicio.icon];
            const esPuntoLimpio = servicio.id === "puntolimpio";
            return (
              <div
                key={servicio.id}
                className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-1"
                data-testid={`servicio-card-${servicio.id}`}
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={servicio.image}
                    alt={servicio.nombre}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <div
                    className="absolute top-4 left-4 w-12 h-12 rounded-xl flex items-center justify-center shadow-lg"
                    style={{ backgroundColor: servicio.color }}
                  >
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <span className="absolute bottom-4 left-4 text-white font-heading font-semibold text-xl">
                    {servicio.nombre}
                  </span>
                </div>
                <div className="p-6">
                  <p className="text-gray-600 mb-4 leading-relaxed">{servicio.descripcion}</p>
                  <p className="text-sm font-medium mb-5" style={{ color: servicio.color }}>
                    {esPuntoLimpio ? servicio.dias : `Días de recogida: ${servicio.dias}`}
                  </p>
                  <Link to={esPuntoLimpio ? "/punto-limpio" : `/solicitud?tipo=${servicio.id}`}>
                    <Button
                      className="w-full sm:w-auto text-white"
                      style={{ backgroundColor: servicio.color }}
                    >
                      {esPuntoLimpio ? "Ir al Punto Limpio Móvil" : `Solicitar ${servicio.nombre.toLowerCase()}`} <ChevronRight className="w-4 h-4 ml-1" />
                    </Button>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
